import { atom } from "recoil";

export const NodeIndexAtom = atom<number>({
  key: "NodeIndexAtom",
  default: -1,
});
